import EditorLeaf from './EditorLeaf.component';

export default EditorLeaf;
